import classNames from 'classnames/bind';
import moment from 'moment';

import withComponentName from '../../../../../decorators/withComponentName';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

export const PresentationTable = ({ presentation }) => {
  const date = presentation.generationDate ? moment(presentation.generationDate).format('DD MMM YYYY') : '';
  const {
    companyName, type, year, period,
  } = presentation || {};

  return (
    <>
      <div className={cx('single_table', 'single_table_desktop')}>
        <table>
          <thead>
            <tr>
              {date && (<th>Date</th>)}
              <th>Legal Entity</th>
              {type && (<th>Type</th>)}
              {year && (<th>Year</th>)}
              {period && (<th>Period</th>)}
            </tr>
          </thead>
          <tbody>
            <tr>
              {date && (<td>{date}</td>)}
              <td>{companyName}</td>
              {type && (<td>{type}</td>)}
              {year && (<td>{year}</td>)}
              {period && (<td>{period}</td>)}
            </tr>
          </tbody>
        </table>
      </div>

      <div className={cx('single_table', 'single_table_tab')}>
        <table>
          <thead>
            <tr>
              {date && (<th>Date</th>)}
              <th>Legal Entity</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {date && (<td>{date}</td>)}
              <td>{companyName}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {(type || year || period) && (
        <div className={cx('single_table', 'single_table_tab')}>
          <table>
            <thead>
              <tr>
                {type && (<th>Type</th>)}
                {year && (<th>Year</th>)}
                {period && (<th>Period</th>)}
              </tr>
            </thead>
            <tbody>
              <tr>
                {type && (<td>{type}</td>)}
                {year && (<td>{year}</td>)}
                {period && (<td>{period}</td>)}
              </tr>
            </tbody>
          </table>
        </div>
      )}

      <SingleCellTable title="Date" value={date} />
      <SingleCellTable title="Legal Entity" value={companyName} />
      <SingleCellTable title="Type" value={type} />
      <SingleCellTable title="Year" value={year} />
      <SingleCellTable title="Period" value={period} />
    </>
  );
};

export const SingleCellTable = ({ title, value }) => {
  if (!value) return null;

  return (
    <div className={cx('single_table', 'single_table_mobile')}>
      <table>
        <thead>
          <tr>
            <th>{title}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{value}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default withComponentName(PresentationTable);
